// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ICipChallengeAnswerRequestDto,
  ICipIdologyResponseDto,
  ICipQuestionnaireAnswersRequestDto,
  IErrorDto,
  IResponseCipInfoDto,
} from '../models/index';
import {
    ICipChallengeAnswerRequestDtoFromJSON,
    ICipChallengeAnswerRequestDtoToJSON,
    ICipIdologyResponseDtoFromJSON,
    ICipIdologyResponseDtoToJSON,
    ICipQuestionnaireAnswersRequestDtoFromJSON,
    ICipQuestionnaireAnswersRequestDtoToJSON,
    IErrorDtoFromJSON,
    IErrorDtoToJSON,
    IResponseCipInfoDtoFromJSON,
    IResponseCipInfoDtoToJSON,
} from '../models/index';

export interface GetCipInfo1Request {
    employeeId?: number;
}

export interface RetrieveDocumentProcessStatusRequest {
    employeeId?: number;
}

export interface SendChallengeAnswerRequest {
    iCipChallengeAnswerRequestDto: ICipChallengeAnswerRequestDto;
}

export interface SendQuestionnaireAnswersRequest {
    iCipQuestionnaireAnswersRequestDto: ICipQuestionnaireAnswersRequestDto;
}

/**
 * CipServiceServiceApi - interface
 * 
 * @export
 * @interface CipServiceServiceApiInterface
 */
export interface CipServiceServiceApiInterface {
    /**
     * 
     * @summary Get CipInfo for authorized employee
     * @param {number} [employeeId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CipServiceServiceApiInterface
     */
    getCipInfo1Raw(requestParameters: GetCipInfo1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IResponseCipInfoDto>>;

    /**
     * Get CipInfo for authorized employee
     */
    getCipInfo1(requestParameters: GetCipInfo1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IResponseCipInfoDto>;

    /**
     * 
     * @summary Retrieve CIP challenge
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CipServiceServiceApiInterface
     */
    retrieveChallengesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ICipIdologyResponseDto>>;

    /**
     * Retrieve CIP challenge
     */
    retrieveChallenges(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ICipIdologyResponseDto>;

    /**
     * 
     * @summary Retrieve document process status
     * @param {number} [employeeId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CipServiceServiceApiInterface
     */
    retrieveDocumentProcessStatusRaw(requestParameters: RetrieveDocumentProcessStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ICipIdologyResponseDto>>;

    /**
     * Retrieve document process status
     */
    retrieveDocumentProcessStatus(requestParameters: RetrieveDocumentProcessStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ICipIdologyResponseDto>;

    /**
     * 
     * @summary Send CIP challenge answer
     * @param {ICipChallengeAnswerRequestDto} iCipChallengeAnswerRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CipServiceServiceApiInterface
     */
    sendChallengeAnswerRaw(requestParameters: SendChallengeAnswerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ICipIdologyResponseDto>>;

    /**
     * Send CIP challenge answer
     */
    sendChallengeAnswer(requestParameters: SendChallengeAnswerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ICipIdologyResponseDto>;

    /**
     * 
     * @summary Send CIP questionnaire answers
     * @param {ICipQuestionnaireAnswersRequestDto} iCipQuestionnaireAnswersRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CipServiceServiceApiInterface
     */
    sendQuestionnaireAnswersRaw(requestParameters: SendQuestionnaireAnswersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ICipIdologyResponseDto>>;

    /**
     * Send CIP questionnaire answers
     */
    sendQuestionnaireAnswers(requestParameters: SendQuestionnaireAnswersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ICipIdologyResponseDto>;

}

/**
 * 
 */
export class CipServiceServiceApi extends runtime.BaseAPI implements CipServiceServiceApiInterface {

    /**
     * Get CipInfo for authorized employee
     */
    async getCipInfo1Raw(requestParameters: GetCipInfo1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IResponseCipInfoDto>> {
        const queryParameters: any = {};

        if (requestParameters['employeeId'] != null) {
            queryParameters['employee_id'] = requestParameters['employeeId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/cip-infos/employee-id`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IResponseCipInfoDtoFromJSON(jsonValue));
    }

    /**
     * Get CipInfo for authorized employee
     */
    async getCipInfo1(requestParameters: GetCipInfo1Request = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IResponseCipInfoDto> {
        const response = await this.getCipInfo1Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve CIP challenge
     */
    async retrieveChallengesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ICipIdologyResponseDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/idology/challenge`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ICipIdologyResponseDtoFromJSON(jsonValue));
    }

    /**
     * Retrieve CIP challenge
     */
    async retrieveChallenges(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ICipIdologyResponseDto> {
        const response = await this.retrieveChallengesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Retrieve document process status
     */
    async retrieveDocumentProcessStatusRaw(requestParameters: RetrieveDocumentProcessStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ICipIdologyResponseDto>> {
        const queryParameters: any = {};

        if (requestParameters['employeeId'] != null) {
            queryParameters['employee_id'] = requestParameters['employeeId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/idology/document-process-status`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ICipIdologyResponseDtoFromJSON(jsonValue));
    }

    /**
     * Retrieve document process status
     */
    async retrieveDocumentProcessStatus(requestParameters: RetrieveDocumentProcessStatusRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ICipIdologyResponseDto> {
        const response = await this.retrieveDocumentProcessStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Send CIP challenge answer
     */
    async sendChallengeAnswerRaw(requestParameters: SendChallengeAnswerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ICipIdologyResponseDto>> {
        if (requestParameters['iCipChallengeAnswerRequestDto'] == null) {
            throw new runtime.RequiredError(
                'iCipChallengeAnswerRequestDto',
                'Required parameter "iCipChallengeAnswerRequestDto" was null or undefined when calling sendChallengeAnswer().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/idology/challenge-answers`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ICipChallengeAnswerRequestDtoToJSON(requestParameters['iCipChallengeAnswerRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ICipIdologyResponseDtoFromJSON(jsonValue));
    }

    /**
     * Send CIP challenge answer
     */
    async sendChallengeAnswer(requestParameters: SendChallengeAnswerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ICipIdologyResponseDto> {
        const response = await this.sendChallengeAnswerRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Send CIP questionnaire answers
     */
    async sendQuestionnaireAnswersRaw(requestParameters: SendQuestionnaireAnswersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ICipIdologyResponseDto>> {
        if (requestParameters['iCipQuestionnaireAnswersRequestDto'] == null) {
            throw new runtime.RequiredError(
                'iCipQuestionnaireAnswersRequestDto',
                'Required parameter "iCipQuestionnaireAnswersRequestDto" was null or undefined when calling sendQuestionnaireAnswers().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/idology/questionnaire-answers`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ICipQuestionnaireAnswersRequestDtoToJSON(requestParameters['iCipQuestionnaireAnswersRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ICipIdologyResponseDtoFromJSON(jsonValue));
    }

    /**
     * Send CIP questionnaire answers
     */
    async sendQuestionnaireAnswers(requestParameters: SendQuestionnaireAnswersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ICipIdologyResponseDto> {
        const response = await this.sendQuestionnaireAnswersRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
